import EntryLayout from './EntryLayout'

export default EntryLayout
